import { useEffect } from 'react';
import { useDataContext } from '../context/data';
import translations from '../constants/translations.json';

// Same flow as GogiLanding (app or browser before joining the table's group
// order), dressed in Maido's own look from maido.dk: white logo, Inter,
// white square-ish buttons on a dark photo.
const INTER_HREF = 'https://fonts.googleapis.com/css2?family=Inter:wght@500;600&display=swap';
const font = { fontFamily: "'Inter', 'DM Sans', system-ui, sans-serif" };
const textShadow = { textShadow: '0 1px 8px rgba(0, 0, 0, 0.6)' };

export default function MaidoLanding({ onOrderViaMobile, onOrderViaBrowser }) {
  const { language } = useDataContext();

  const translation = translations[language] || translations['en'] || {};

  useEffect(() => {
    if (document.querySelector(`link[href="${INTER_HREF}"]`)) return;
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = INTER_HREF;
    document.head.appendChild(link);
  }, []);

  const buttonClass =
    'bg-white hover:bg-[#e6e6e6] active:translate-y-px text-black text-[13px] md:text-[14px] font-semibold uppercase tracking-[0.1em] border-none cursor-pointer px-[36px] md:px-[44px] py-[13px] md:py-[15px] rounded-[4px] transition-colors duration-200';
  const subheadingClass =
    'text-[14px] md:text-[16px] font-medium leading-none text-white uppercase tracking-[0.12em]';

  return (
    <div
      className="relative min-h-screen bg-black bg-cover bg-center bg-no-repeat flex items-start justify-center"
      style={{ backgroundImage: "url('/maido-bg.webp')", ...font }}
    >
      {/* Dark overlay */}
      <div className="absolute inset-0 bg-black/[0.6] pointer-events-none" />

      {/* Content column */}
      <div className="relative z-10 flex flex-col items-center text-center w-full max-w-[1128px] gap-[10px] pb-[100px]">
        {/* Logo */}
        <div className="my-[50px]">
          <img
            src="/maido-logo-white.svg"
            alt="Maido – sushi, cocktails, lounge"
            className="w-[230px] md:w-[300px] h-auto block"
          />
        </div>

        {/* Main heading */}
        <h4
          className="text-[24px] md:text-[30px] font-medium leading-[1.2] text-white uppercase tracking-[0.04em] pb-8"
          style={textShadow}
        >
          {translation.maido_welcome || 'Velkommen til Maido'}
        </h4>

        <div className="space-y-10">
          {/* Order via app */}
          <div className="space-y-4">
            <h4 className={subheadingClass} style={textShadow}>
              {translation.gogi_order_via_app || 'Order via app'}
            </h4>
            <button onClick={onOrderViaMobile} className={buttonClass} style={font}>
              {translation.gogi_order_here || 'Bestil her'}
            </button>
          </div>

          {/* Order via browser */}
          <div className="space-y-4">
            <h4 className={subheadingClass} style={textShadow}>
              {translation.gogi_order_via_browser || 'Order via browser'}
            </h4>
            <button onClick={onOrderViaBrowser} className={buttonClass} style={font}>
              {translation.gogi_order_here || 'Bestil her'}
            </button>
          </div>
        </div>

        {/* Heywaitr branding */}
        <div className="pt-16">
          <img src="/heywaitr-logo.png" alt="heywaitr" className="w-[150px] h-auto block" />
        </div>
      </div>
    </div>
  );
}
